export default __webpack_public_path__ + "static/media/hr.43ed8320.svg";